import {createSelector} from '@reduxjs/toolkit';

import values from '@tinkoff/utils/object/values';

import {getAllChannels} from 'mattermost-redux/selectors/entities/channels';
import type {RootState} from 'stores/redux_store';
import {isDirectChannel} from 'utils/isDirectChannel';
import {type DirectChannel} from '@mattermost/types/channels';

export const getDMChannelsForTeam = createSelector(
    getAllChannels,
    (_: RootState, teamId: string) => teamId,
    (allChannelsSet, teamId) => {
        return values(allChannelsSet).filter((channel): channel is DirectChannel => {
            if (!isDirectChannel(channel)) {
                return false;
            }

            // @TODO: DM каналы пока что шарятся на все команды, поэтому тут возвращаем true
            if (!channel.team_id) {
                return true;
            }

            return channel.team_id === teamId;
        });
    },
);
